import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { IFinancialReportListResponse, IEligibilityResponse } from '../models';
import { IBaseResponse } from '@carm/_utils/models';
import { HttpParams } from '@angular/common/http';
import { LoaderSpinnerTypes } from '@carm/_core';
import { utcEndDayTime, utcStartDayTime } from '@carm/_utils/utility-functions';

@Injectable()
export class FinancialReportService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  get baseCadReportUrlBP(): string {
    return this.endPointBP + '/cad/report';
  }

  getEligibility(
    startDate: string,
    endDate: string,
    searchString: string,
    type: string[],
    mostRecentVersionOnly: boolean
  ): Observable<IEligibilityResponse> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('sort', 'creationtime:desc')
      .set('mostRecentVersionOnly', mostRecentVersionOnly.toString())
      .set('searchString', searchString);
    const endPoint = `${this.baseCadReportUrlBP}/request/eligibility`;
    return this.httpAuthGet<IEligibilityResponse>(endPoint, params);
  }

  submitRequest(
    startDate: string,
    endDate: string,
    searchString: string,
    type: string[],
    mostRecentVersionOnly: boolean
  ): Observable<IBaseResponse> {
    const payload = {
      advancedFilterString: searchString,
      startDate: startDate,
      endDate: endDate,
      mostRecentVersionOnly: mostRecentVersionOnly,
      declarationTypes: type,
    };

    const endPoint = `${this.baseCadReportUrlBP}/request`;
    return this.httpAuthPost<IBaseResponse>(endPoint, payload);
  }


  public getReports(
    searchString: string,
    minDate: Date,
    maxDate: Date,
    sortField: string,
    currentPage: number,
    pageSize: number
  ): Observable<IFinancialReportListResponse> {
    const endPoint = `${this.baseCadReportUrlBP}/list`;
    const params = this.getHttpPameter(
      searchString,
      minDate,
      maxDate,
      sortField,
      currentPage,
      pageSize
    );
    return this.httpAuthGet<IFinancialReportListResponse>(endPoint, params, LoaderSpinnerTypes.AgGrid);
  }


  cancelReport(caseId: string): Observable<IBaseResponse> {
    const endPoint = `${this.baseCadReportUrlBP}/request/${caseId}`;
    return this.httpAuthDelete<IBaseResponse>(endPoint);
  }

  private getHttpPameter(
    searchString: string,
    startDate: Date,
    endDate: Date,
    sortField: string,
    currentPage: number,
    pageSize: number
  ): HttpParams {
    const params = new HttpParams()
      .set('currentPage', currentPage.toString())
      .set('pageSize', pageSize.toString())
      .set(
        'startDate',
        utcStartDayTime(startDate)
      ) // default to today - 100years
      .set(
        'endDate',
        utcEndDayTime(endDate)
      ) // default to today + 1 day
      .set('reportSort', sortField)
      .set('searchString', searchString || null);
    return params;
  }
}
